import Editor from './Editor';

export default Editor;
export * from './Editor';
